import { createWsConnectThunks, WsPrefixes } from '@skynet/data-ws-core';
import type { WsMmState } from './slice';

export type MmWsState = { wsMm: WsMmState };

const {
  wsLogout,
  wsDisconnect,
  subscribeWsData: subscribeWsMmData,
} = createWsConnectThunks({
  sliceKey: 'wsMm',
  prefix: WsPrefixes.mmPrefix,
  logoutCommand: 'Logout',
  disconnectCommand: 'Disconnect',
});

export { wsLogout as wsMmLogout, wsDisconnect as wsMmDisconnect, subscribeWsMmData };
